import { getEnv, EnvType } from '@atlassian/help-center-common-util/env';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function devLog(message?: any, ...optionalParams: any[]): void {
	const env = getEnv();

	// eslint-disable-next-line no-console
	env.environment !== EnvType.PROD && console.log(message, ...optionalParams);
}
